define(function(require) {
  const tpl = require('./t_cpv_document_box.hbs');
  const ViewManager = require('civicsUtils/view_manager');
  const ReportViewUtilities = require('civicsViews/view_documents/report_view_utilities');
  const DocumentView = require('civicsViews/view_documents/v_itv_view_document.js');


  return Marionette.CompositeView.extend({
    template: tpl,
    className: 'v_cpv_document_box',
    childViewContainer: '.report-types',
    childView: DocumentView,
    childEvents: {
      'error:loading': 'displayError'
    },
    childViewOptions: function() {
      return {
        modalRegion: this.modalRegion,
        inModalView: false,
      }
    },
    ui: {
      myDocumentsBox: '.mydocuments-box',
      downloadLinkSpan: '.link-download',
      errorRegion: '.error-region'
    },
    initialize: function(options) {
      //options
      this.modalRegion = options.modalRegion;

      var globalConfig = ViewManager.globalConfig().toJSON();
      this.hideLinkWhenEmpty = globalConfig.reports.hideLinkWhenEmpty;

      this.reportTypes = ReportViewUtilities.getReportTypes(
        options.milestoneType,
        options.applicationType,
        options.instrumentType,
        options.instrumentID,
        options.activeProfiles,
        options.modelId,
        options.useSecuredURL);

      this.collection = new Backbone.Collection(this.reportTypes);


    },
    displayError: function() {
      this.ui.errorRegion.show();
    },
    onRender: function() {
      this.ui.errorRegion.hide();
      if((!this.reportTypes || this.reportTypes.length == 0) && this.hideLinkWhenEmpty) {
        this.ui.myDocumentsBox.hide();
        $('.mydocuments-box-column').hide();
        $('.id-action-fees-payment-row').removeClass('has-document-box');
      }
    },
    templateHelpers: function() {
      return {
        count: this.reportTypes ? this.reportTypes.length : 0
      }
    }

  });

})
